module.exports = __webpack_public_path__ + "img/add-image15.0415cd44.png";